export type AppLocale = "zh-CN" | "en";
export type ThemePreference = "light" | "dark";
export type PreferencePatch = {
  display_name?: string;
  locale?: AppLocale;
  preferences?: { theme?: ThemePreference };
};
export type OnboardingStep = "language_appearance" | "profile" | "data_choices";
export type OnboardingDraft = {
  display_name?: string;
  data_choices?: { history?: boolean; training?: boolean };
};
export type OnboardingState = {
  version: number;
  status: "not_started" | "in_progress" | "completed" | "skipped";
  step: OnboardingStep;
  completed_at: string | null;
  draft: OnboardingDraft;
};
export const normalizeLocale = (value: unknown): AppLocale =>
  value === "en" || value === "en-US" ? "en" : "zh-CN";
